const config = {
     appUrl: process.env.REACT_APP_URL,
}
export default config;